import type { SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';
import type { SocialPostRendition } from './social-post-preview-card';
import { postIsFeedShaped, type PostGridCount } from './social-post-look-parts';

export const LINKEDIN_CAPTION_LIMIT = 250;

export type LinkedinLook = 'linkedin';

export function linkedinLook(card: Pick<SocialPostPreviewCardMetadata, 'postType'>): LinkedinLook | undefined {
  return postIsFeedShaped(card) ? 'linkedin' : undefined;
}

export const LINKEDIN_RENDITIONS: Record<'single' | 'half' | 'quarter', SocialPostRendition> = {
  single: { mode: 'fit', width: 660, height: 1320 },
  half: { mode: 'fill', width: 328, height: 480 },
  quarter: { mode: 'fill', width: 328, height: 238 },
};

export function linkedinGridRendition(count: PostGridCount, index: number): SocialPostRendition {
  return count === 2 || (count === 3 && index === 0) ? LINKEDIN_RENDITIONS.half : LINKEDIN_RENDITIONS.quarter;
}
